import React, { useEffect } from "react";
import { MeetingDetailComponent } from "@hedgefund/shared";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import { deleteMeeting, getMeetingDetails, UpdateMeetingInGoogleCalendar, UpdateMeetingInOutlookCalendar } from "./actions";
import { alertService } from "@hedgefund/shared/src/Alert";

const MeetingDetail = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();
  const meetingDetail = useSelector((state) => state.meetingDetails);

  const { getMeeting } = meetingDetail;

  let splitId = location.search.split("?appointmentId=");
  const appointmentID = splitId[1];

  useEffect(() => {
    if (appointmentID) {
      dispatch(getMeetingDetails(appointmentID));
    }
  }, [appointmentID]);

  const deleteMeetings = () => {
    dispatch(deleteMeeting(appointmentID, onSuccess));
  }
  const updateMeetingInGoogle = (values) => {
    dispatch(UpdateMeetingInGoogleCalendar(values, onSuccessAlert));
  }
  const onSuccessAlert = () => {
    alertService.success(`Update Event in Calendar Succesffuly.`, { autoClose: true });
  }
  const updateMeetingInOutlook = (values) => {
    dispatch(UpdateMeetingInOutlookCalendar(values, onSuccessAlert));
  }
  const onSuccess = () => {
    history.push("/profile?tab=nav-my-meetings-tab")
  }

  return <MeetingDetailComponent
    portal={"allocator"}
    getMeeting={getMeeting}
    deleteMeetings={deleteMeetings}
    updateMeetingInGoogle={updateMeetingInGoogle}
    updateMeetingInOutlook={updateMeetingInOutlook} />;
};

export default MeetingDetail;
